import React from 'react';
import { connect } from 'react-redux';
import { isEGView, isAutomaticLoad, usePermission } from '../../helpers/common';
import LoadTripList from './LoadTripList';
import "../../../assets/scss/load-trip.scss";

const LoadTrip = props => {
    const { analyze: { isTruck, view }, loadTripWorkWindow } = props;
    return usePermission()("farm", "create") && isAutomaticLoad()
        && isTruck && isEGView(view) &&
        <LoadTripList loadTripWorkWindow={loadTripWorkWindow} />;
};

const mapStateToProps = state => ({
    analyze: {
        isTruck: state.analyze.analyzeParams.isTruck,
        view: state.analyze.analyzeParams.view
    }
});

export default connect(mapStateToProps)(LoadTrip);